import React from 'react';
import {AgGridColumn, AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

export default function ReferralsActivityTable(props) {
  const {activities} = props;
  function renderKycStatusStyle(kycStatus) {
    return kycStatus === 'Store Created - Kyc Verified'
    ? 'text-success'
    : 'text-danger';
  }

  function renderKycStatus(kycStatus) {
    return kycStatus === 'Store Created - Kyc Verified'
      ? 'KYC Verified'
      : 'KYC Pending';
  }
  return (
    <div className="ag-theme-alpine">
      <AgGridReact
        rowData={activities}
        pagination={activities.length > 10}
        paginationPageSize={10}
        domLayout="autoHeight"
      >
        <AgGridColumn
          headerName="Store Id"
          field="storeId"
          sortable={true}
          filter={true}
        />
        <AgGridColumn
          headerName="Store URL"
          field="URL"
          sortable={true}
          filter={true}
        />
        <AgGridColumn
          headerName="Phone Number"
          field="phoneNumber"
          sortable={true}
          filter={'agNumberColumnFilter'}
        />
        <AgGridColumn
          headerName="Account Created On"
          field="accountCreated"
          sortable={true}
          filter={'agDateColumnFilter'}
        />
        <AgGridColumn
          headerName="Subscription Plan"
          field="subscriptionPlan"
          sortable={true}
          filter={true}
        />
        <AgGridColumn
          headerName="Status"
          field="status"
          sortable={true}
          filter={true}
          valueFormatter={renderKycStatus}
          cellClass={renderKycStatusStyle}
        />
      </AgGridReact>
    </div>
  );
}
